export class UploadUserListData {
  public static readonly type = '[UserListUpload] Upload';
  constructor(public payload: { language: string; userTimezone: string; userCountry: string; file: File }) {}
}
export class UserListUploadInitialState {
  public static readonly type = '[UserListUpload] Set initial state';
}
